<!-- Created by Alex Poh. on 29/03/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<curr-drawing-board color="red" weight="15" [clear$]="clear$"></curr-drawing-board>
<button (click)="clear()">Clear</button>
